import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyState = ({ 
  searchQuery, 
  hasActiveFilters, 
  onClearFilters, 
  onNewSearch,
  onBrowseAll 
}) => {
  const suggestions = [
    'Try different keywords',
    'Check your spelling',
    'Use more general terms',
    'Remove some filters',
    'Browse popular destinations'
  ];

  const popularSearches = [
    'Beach tours in Bali',
    'Paris city walking tours',
    'Adventure tours in Costa Rica',
    'Food tours in Tokyo',
    'Safari tours in Kenya',
    'Northern Lights tours'
  ];

  return (
    <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
      {/* Icon */}
      <div className="w-24 h-24 bg-muted rounded-full flex items-center justify-center mb-6">
        <Icon name="Search" size={48} className="text-muted-foreground" />
      </div>
      {/* Main Message */}
      <h2 className="text-2xl font-semibold text-foreground mb-3">
        {searchQuery ? `No tours found for "${searchQuery}"` : 'No tours match your criteria'}
      </h2>
      <p className="text-muted-foreground mb-8 max-w-md">
        {hasActiveFilters 
          ? "Try adjusting your filters or search for different criteria to find more tours."
          : "We couldn't find any tours matching your search. Here are some suggestions to help you find what you're looking for."
        }
      </p>
      {/* Action Buttons */}
      <div className="flex flex-col sm:flex-row gap-3 mb-8">
        {hasActiveFilters && (
          <Button
            variant="outline"
            onClick={onClearFilters}
            iconName="X"
            iconPosition="left"
          >
            Clear All Filters
          </Button>
        )}
        
        <Button
          onClick={onNewSearch}
          iconName="Search"
          iconPosition="left"
        >
          Try New Search
        </Button>
        
        <Button
          variant="outline"
          onClick={onBrowseAll}
          iconName="Compass"
          iconPosition="left"
        >
          Browse All Tours
        </Button>
      </div>
      {/* Suggestions */}
      <div className="w-full max-w-2xl">
        <h3 className="text-lg font-medium text-foreground mb-4">Suggestions:</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-8">
          {suggestions?.map((suggestion, index) => (
            <div key={index} className="flex items-center space-x-2 text-left">
              <Icon name="CheckCircle" size={16} className="text-green-500 flex-shrink-0" />
              <span className="text-muted-foreground">{suggestion}</span>
            </div>
          ))}
        </div>

        {/* Popular Searches */}
        <div className="border-t border-border pt-8">
          <h3 className="text-lg font-medium text-foreground mb-4">Popular Searches:</h3>
          <div className="flex flex-wrap gap-2 justify-center">
            {popularSearches?.map((search, index) => (
              <button
                key={index}
                onClick={() => onNewSearch(search)}
                className="px-4 py-2 bg-muted hover:bg-muted-foreground/10 text-muted-foreground hover:text-foreground rounded-full text-sm transition-colors"
              >
                {search}
              </button>
            ))}
          </div>
        </div>
      </div>
      {/* Help Section */}
      <div className="mt-12 p-6 bg-muted rounded-lg max-w-md">
        <Icon name="HelpCircle" size={24} className="text-primary mx-auto mb-3" />
        <h4 className="font-medium text-foreground mb-2">Need Help?</h4>
        <p className="text-sm text-muted-foreground mb-4">
          Our travel experts are here to help you find the perfect tour experience.
        </p>
        <Button variant="outline" size="sm" iconName="MessageCircle" iconPosition="left">
          Contact Support
        </Button>
      </div>
    </div>
  );
};

export default EmptyState;